module.exports = __webpack_public_path__ + "fonts/NunitoSans-Light.8fde328.ttf";